module.exports = __webpack_public_path__ + "img/page-not-found.8c38cd7b.jpg";